import { useMutation } from '@tanstack/react-query';

import { airBundleDocumentsApi } from 'api';
import {
  type InsuranceType,
  type AirBundleDocumentParam,
} from 'types/airBundleDocuments';

const useUploadAirBundleDocuments = () => {
  const uploadAirBundleDocumentMutation = useMutation({
    mutationFn: (params: {
      journeyId: number;
      file: File;
      insuranceType: InsuranceType;
      insuranceId: number;
      documentType: AirBundleDocumentParam;
    }) =>
      airBundleDocumentsApi.uploadDocument(
        params.file,
        params.insuranceType,
        params.documentType,
        params.journeyId,
        params.insuranceId,
      ),
  });
  return uploadAirBundleDocumentMutation;
};
export default useUploadAirBundleDocuments;
